import React, { useState } from "react";
import Header from "../components/header";
import SidebarHeader from "../components/sidebarHeader";
import { useMediaQuery } from "react-responsive";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { GiProgression } from "react-icons/gi";
import "./styles.css";
import PricingCard from "../components/PricingCard";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import pricing from "../assets/home/pricing.jpg";

const ContactUS = () => {
  // State
  const [menu, setMenu] = useState("");
  const [pack, setPack] = useState(false);

  // Query
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1150px)",
  });
  const isLang = useSelector((state) => state.authReducer.lang);

  //   Carosil
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mdtablet: {
      breakpoint: { max: 992, min: 464 },
      items: 2,
    },

    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  //   Function
  const handleMouseOver = (type) => {
    setMenu(type);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <Header menu={menu} setMenu={setMenu} />
      ) : (
        <SidebarHeader />
      )}
      <div onMouseOver={() => handleMouseOver("")} className="text-black">
        <section className="custon-section w-full">
          <div className="custon-container">
            <p
              className="font-[700] text-[26px] md:text-[32px] flex items-center justify-center bg-gradient-to-r from-purple-700 to-purple-800 lg:text-[32px] text-center py-20"
              style={{
                fontFamily: "poppins",
                height: "250px",
                color: "#FFF",
              
              }}
            >
          {isLang==='eng' ? "Contact Us" : "أتصل بنا"}
            </p>

            <div className="bg-white shadow-lg text-center rounded-lg p-8 w-full mt-4">
       
        <p className="text-lg text-gray-700 mb-4">
          {isLang !== "arabic"
            ? "We're here to help! Be it a question, need support, or just want to chat about your design project, we'd love to hear from you."
            : "نحن هنا للمساعدة! سواء كان ذلك سؤالاً، أو كنت بحاجة إلى الدعم، أو كنت ترغب فقط في الدردشة حول مشروع التصميم الخاص بك، فنحن نحب أن نسمع منك."}
        </p>

        <h2 className="text-2xl font-semibold mb-4">
          {isLang !== "arabic" ? "Here are the ways you can reach us:" : "فيما يلي الطرق التي يمكنك من خلالها الوصول إلينا:"}
        </h2>

        <p className="text-lg text-gray-700 mb-4">
          {isLang !== "arabic"
            ? "Email: support@maker4u.com - Our experienced customer support staff stand by to address your inquiries 24/7 by email."
            : "البريد الإلكتروني: support@maker4u.com - فريق دعم العملاء الخبير لدينا جاهز للرد على استفساراتك على مدار الساعة طوال أيام الأسبوع عبر البريد الإلكتروني."}
        </p>

        <p className="text-lg text-gray-700 mb-4">
          {isLang !== "arabic"
            ? "Have you got any issues related to your account and subscription?"
            : "هل لديك أي مشاكل تتعلق بحسابك واشتراكك؟"}
        </p>

        <a href="/" className="text-lg text-blue-600 underline mb-4 cursor-pointer">
          {isLang !== "arabic"
            ? "Visit our Help Center"
            : "تفضل بزيارة مركز المساعدة الخاص بنا"}
        </a>
        <br></br>

        <a href="/" className="text-lg text-blue-600 underline mb-4 cursor-pointer">
          {isLang !== "arabic"
            ? "Submit a Support Ticket"
            : "إرسال تذكرة دعم"}
        </a>

        <p className="text-lg text-gray-700 mb-4">
          {isLang !== "arabic"
            ? "The customer is the priority, and that is why we've decided to ensure that each of our clients will receive the highest level of customer service. An email response in no more than 24 hours during weekdays is our target."
            : "العميل هو الأولوية، ولهذا السبب قررنا التأكد من أن كل عميل من عملائنا سيحصل على أعلى مستوى من خدمة العملاء. هدفنا هو الرد عبر البريد الإلكتروني في مدة لا تزيد عن 24 ساعة خلال أيام الأسبوع."}
        </p>

        <p className="text-lg text-gray-700">
          {isLang !== "arabic"
            ? "Let us hear if we have managed your Maker4U journey perfectly. Providing a platform for your feedback isn't a matter of sitting around and replying to any email we send or using the contact methods above."
            : "قم بإعلامنا ما إذا كنا قد تمكنا من إدارة رحلتك إلى Maker4U بشكل مثالي. إن توفير منصة لتعليقاتك لا يعني فقط الجلوس والرد على أي بريد إلكتروني نرسله أو استخدام طرق الاتصال المذكورة أعلاه."}
        </p>
      </div>
            <div className="">
              <div className=" text-black ">
              <div className="mt-5 grid grid-cols-6 gap-4">
  <div
    className="mb-3 col-start-2 col-span-4 py-10"
    style={{ textAlign: isLang === "arabic" ? "right" : "left" }}
  >
    <p className="text-[28px] font-[400]" style={{ fontFamily: "poppins" }}>
      {isLang === "eng" ? "Submit a request" : "إرسال طلب"}
    </p>
    <p className="text-[16px] font-[400]" style={{ fontFamily: "poppins" }}>
      {isLang === "eng"
        ? "In Case of Any Query please contact us by filling the below form details:"
        : "في حال وجود أي استفسار، يرجى الاتصال بنا عن طريق ملء تفاصيل النموذج أدناه:"}
    </p>
  </div>

  <div
    className="mb-3 col-start-2 col-span-4 py-3"
    style={{ textAlign: isLang === "arabic" ? "right" : "left" }}
  >
    <label
      className="form-label text-lg font-normal py-0 m-2"
      style={{ fontFamily: "poppins", color: "#808080", fontSize: "14px" }}
      htmlFor="name"
    >
      {isLang === "eng" ? "Name" : "الاسم"}
    </label>
    <br />
    <input
      className="form-control p-3 focus:outline-none rounded-md m-2"
      style={{
        border: "solid",
        borderColor: "#808080",
        borderWidth: "1px",
        width: "100%",
        textAlign: isLang === "arabic" ? "right" : "left",
      }}
      type="text"
      placeholder={isLang === "eng" ? "Enter Your Name" : "أدخل اسمك"}
      id="name"
      required
    />
  </div>

  <div
    className="mb-3 col-start-2 col-span-4 py-3"
    style={{ textAlign: isLang === "arabic" ? "right" : "left" }}
  >
    <label
      className="form-label text-lg font-normal py-0 m-2"
      style={{ fontFamily: "poppins", color: "#808080", fontSize: "14px" }}
      htmlFor="email"
    >
      {isLang === "eng" ? "Email" : "البريد الإلكتروني"}
    </label>
    <br />
    <input
      className="form-control p-3 focus:outline-none rounded-md m-2"
      style={{
        border: "solid",
        borderColor: "#808080",
        borderWidth: "1px",
        width: "100%",
        textAlign: isLang === "arabic" ? "right" : "left",
      }}
      type="email"
      placeholder={isLang === "eng" ? "Enter Your Email" : "أدخل بريدك الإلكتروني"}
      id="email"
      required
    />
  </div>

  <div
    className="mb-3 col-start-2 col-span-4 py-3"
    style={{ textAlign: isLang === "arabic" ? "right" : "left" }}
  >
    <label
      className="form-label text-lg font-normal py-0 m-2"
      style={{ fontFamily: "poppins", color: "#808080", fontSize: "14px" }}
      htmlFor="subject"
    >
      {isLang === "eng" ? "Subject" : "الموضوع"}
    </label>
    <br />
    <input
      className="form-control p-3 focus:outline-none rounded-md m-2"
      style={{
        border: "solid",
        borderColor: "#808080",
        borderWidth: "1px",
        width: "100%",
        textAlign: isLang === "arabic" ? "right" : "left",
      }}
      type="text"
      placeholder={isLang === "eng" ? "Enter Your Subject" : "أدخل موضوعك"}
      id="subject"
      required
    />
  </div>

  <div
    className="mb-3 col-start-2 col-span-4 py-3"
    style={{ textAlign: isLang === "arabic" ? "right" : "left" }}
  >
    <label
      className="form-label text-lg font-normal py-0 m-2"
      style={{ fontFamily: "poppins", color: "#808080", fontSize: "14px" }}
      htmlFor="description"
    >
      {isLang === "eng" ? "Description" : "الوصف"}
    </label>
    <br />
    <textarea
      className="form-control p-3 focus:outline-none rounded-md m-2"
      style={{
        border: "solid",
        borderColor: "#808080",
        borderWidth: "1px",
        width: "100%",
        height: "200px",
        textAlign: isLang === "arabic" ? "right" : "left",
      }}
      placeholder={isLang === "eng" ? "Enter Description" : "أدخل الوصف"}
      id="description"
      required
    />
  </div>

  <div
    className="mb-3 col-start-2 col-span-4 py-3 flex items-center justify-center"
    style={{ textAlign: isLang === "arabic" ? "right" : "left" }}
  >
    <button
      className="btn btn-danger bg-blue-800 text-white hover:outline-none p-3 rounded-md"
      style={{ width: "50%" }}
      type="submit"
    >
      {isLang === "eng" ? "Submit" : "إرسال"}
    </button>
  </div>
</div>

              </div>
            </div>
          </div>
        </section>

        <footer>
          <Footer />
        </footer>
      </div>
    </>
  );
};

export default ContactUS;
